import React from "react";
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatNumberToCurrency } from "../../../../common/formatter";
import NumericalTextBox from "@instream-solutions/instream-design-system/lib/UX/NumericalTextBox/NumericalTextBox";

const columns = [
  {
    id: "sortOrder",
    label: "Order No.",
    minWidth: 150,
  },
  {
    id: "accountType",
    label: "Account Type",
    minWidth: 350,
  },
  {
    id: "currentValue",
    label: "Balance Amount",
    minWidth: 350,
  },
];

const AssetDistributionSort = (props) => {
  return (
    <Grid item md={12} className="asset-distribution-sort-component">
      <Grid item>
        <Typography component="h5">Asset Distribution Rank</Typography>
        <Typography component={"label"}>
          Plan Wizard has evaluated that the Client record contains more than
          one asset account. Please organize the distribution order by numbering
          the accounts in the below table, starting with 1.
        </Typography>
      </Grid>
      <Grid item>
        <Card className="asset-rmd-card">
          <Grid
            container
            spacing={4}
            justifyContent="space-between"
            className="monthly-expenses-inputs"
          >
            <Grid item>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.assets.map((asset, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Grid item>
                            <NumericalTextBox
                              min={1}
                              max={100}
                              format={"n0"}
                              decimals={0}
                              value={asset.sortOrder}
                              update={(event) =>
                                props.update(asset, event.target.value)
                              }
                              valid={
                                props.assets.filter((a) => {
                                  if (asset.editIndex === a.editIndex)
                                    return false;
                                  return asset.sortOrder === a.sortOrder;
                                }).length === 0 &&
                                asset.sortOrder <= props.assets.length
                              }
                            />
                          </Grid>
                        </TableCell>
                        <TableCell>
                          <Grid item>
                            <Typography component={"label"}>
                              {asset.accountType.name}
                            </Typography>
                          </Grid>
                        </TableCell>
                        <TableCell>
                          <Grid item>
                            <Typography component={"label"}>
                              {formatNumberToCurrency(asset.currentValue)}
                            </Typography>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AssetDistributionSort;
